import { Link, useSearchParams } from "react-router-dom";
import { UserForm } from "../Form";
import { useSelector } from "react-redux";
import { GrantingPermission } from "../GrantingPermission";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PageNotFound from "../../notfound";

export const CreateUser = () => {
  const navigate = useNavigate();

  const inputList = [
    {
      label: "Họ tên nhân viên",
      required: true,
      key: "fullname",
    },
    {
      label: "Tên đăng nhập",
      required: true,
      key: "username",
    },
    {
      label: "Mật khẩu",
      required: true,
      type: "password",
      key: "password",
    },
    {
      label: "Xác nhận mật khẩu",
      required: true,
      reference: "password",
      type: "password",
      key: "reEnterPassword",
    },
    { label: "Email", key: "email" },
    { label: "Số điện thoại", key: "phone" },
    { label: "Địa chỉ", key: "address" },
    { label: "Ghi chú", key: "note" },
  ];
  const TABS = {
    i: "info",
    g: "grantPermission",
    info: "i",
    grantPermission: "g",
  };
  const Links = [
    { to: "./?tab=i", content: "Thông tin nhân viên", key: "info" },
    { to: "./?tab=g", content: "Cấp quyền quản lý", key: "grantPermission" },
  ];
  const _token = localStorage.getItem("_token");
  const { proxy, auth, lang } = useSelector((s) => s);
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = TABS[searchParams.get("tab")] || "info";
  const [userInfo, setUserInfo] = useState({});
  const [selectedValues, setSelectedValues] = useState({
    warehouses: [],
    storages: [],
  });

  if (
    !["uad", "pm"].includes(auth?.role) &&
    !auth?.ct?.find(
      ({ table_alias, write }) => table_alias === "accounts" && write
    )
  ) {
    return <PageNotFound />;
  }

  const handleSignup = async () => {
    const response = await fetch(`${proxy()}/auth/v2/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `${_token}`,
      },
      body: JSON.stringify(userInfo),
    });
    const result = await response.json();
    const { success, message } = result;
    Swal.fire({
      title: success ? lang["success.add"] : lang["fail.add"],
      text: lang[message] || message,
      icon: success ? "success" : "error",
      showConfirmButton: success ? false : true,
      timer: success && 1500,
    }).then(() => {
      if (success) {
        navigate("/users");
      }
    });
  };

  const Components = {
    info: (
      <UserForm
        action_btn={lang["continue"]}
        onChange={(payload) => {
          setUserInfo((prev) => ({ ...prev, ...payload }));
        }}
        user={userInfo}
        cb={(payload) => {
          handleSignup();
        }}
        inputList={inputList}
        isAdd={true}
      />
    ),
    grantPermission: (
      <GrantingPermission
        setSelectedValues={setSelectedValues}
        selectedValues={selectedValues}
        value={userInfo.warehouses}
        privilegeGroupsValue={userInfo?.["privilegeGroup"] || []}
        onChange={(payload) => {
          if (payload.key === "privilegeGroup") {
            setUserInfo((prev) => ({ ...prev, [payload.key]: payload.value }));
            return;
          }
          setUserInfo((prev) => {
            const storages = [
              ...new Set(
                selectedValues?.storages.map(({ KV }) => KV?.["7MKV"])
              ),
            ];

            const warehouses = [
              ...new Set(selectedValues?.storages.map(({ value }) => value)),
            ];
            return {
              ...prev,
              warehouses,
              storages,
            };
          });
        }}
        isAdd={true}
        cb={(payload) => {
          handleSignup();
        }}
        tempUserInfor={userInfo}
      />
    ),
  };

  return (
    <div className="container-fluid">
      <div className="page_title">
        {/* <h4>{lang["accounts manager"]}</h4> */}
      </div>
      <div
        className="content"
        style={{
          marginLeft: "-15px",
          marginRight: "-15px",
        }}
      >
        <div
          className="white_shd full d-flex flex-column"
          style={{
            height: "89vh",
          }}
        >
          <div
            className="full graph_head"
            style={{
              borderBottom: " 1px solid rgb(221, 221, 221)",
            }}
          >
            <div className="heading1 margin_0">
              <h5>
                <label className="pointer m-0">
                  <a>
                    <i className="fa fa-chevron-circle-left mr-1 nav-item nav-link"></i>
                  </a>
                  <span onClick={() => navigate("/users")}>
                    {lang["accounts manager"]}
                  </span>
                  <i className="fa fa-chevron-right ml-2 mr-1 "></i>
                  {lang["add"]}
                </label>
              </h5>
            </div>
          </div>
          <div
            className="navbar_container mt-2"
            style={{
              borderBottom: "1px solid #ddd",
              padding: "10px 15px",
            }}
          >
            <ul>
              {Links.map(({ to, content, key }, i) => (
                <li className="float-left">
                  <Link
                    to={to}
                    className={`font-weight-bold item ${
                      tab === key ? "active" : ""
                    }`}
                    key={key}
                    style={{
                      padding: "10px 15px",
                      // color: tab === key && "#0066cc",
                      border: tab === key && "1px solid #ddd",
                      borderBottomColor: tab === key && "#00000000",
                      backgroundColor: tab === key && "#fff",
                    }}
                  >
                    {content}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div
            className="mt-4"
            style={{
              height: "70vh",
              overflow: "auto",
            }}
          >
            {Components[tab]}
          </div>
        </div>
      </div>
    </div>
  );
};
